//////LIBRARY//////
import React, { Fragment, useEffect, useState, useMemo } from 'react'
import { cloneDeep, isEmpty, isEqual, reduce, find, forEach, isUndefined, map, isNull, get, findIndex } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { recapStockActionsCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import theme from '../../theme/theme'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import urlExport from '../../constants/UrlExport'
import TableTitle from '../../components/Table/components/TableTitle'
import convertHexToRGBA from '../../helpers/HexToRgba'
//////ASSETS//////
import ErrorSign from '../../assets/icones/global/warning-red.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const AlertStockColor = styled.div`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => convertHexToRGBA(props.color, 0.2)};
	color: ${(props) => props.color};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
const InputErrorTableWrapper = styled.div`
	display: grid;
	grid-template-columns: ${(props) => (props.errors ? 'max-content 2fr' : '1fr')};
	justify-content: center;
	align-items: center;
	grid-column-gap: 10px;
	width: max-content;
`
const InputTableRow = styled.input`
	width: 80px;
	padding: 5px;
`
const ErrorInputTable = styled.img`
	max-height: 32px;
`
//////STYLED//////

const RecapStock = (props) => {
	// region USE STATE ....
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'kiosk.store.company.labelToDisplay', nameDir: 'asc' })
	const [prevFilter, setPrevFilter] = useState()
	const [columns, setColumns] = useState([])
	const [isSorting, setIsSorting] = useState(false)
	const [configTableTitle, setConfigTableTitle] = useState({
		paging: {
			fnSendTo: (paging) => handlePagingRecap(paging),
		},
	})
	const [configTable, setConfigTable] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// inline edit object editKey id object UNIQ and edit key is mapper to editKey in row selected ( example in /RecapStock/ActionsTable )
	const [inLineEdit, setInlineEdit] = useState({
		editId: null,
		editKey: '',
	})
	//endregion

	//region USE SELECTOR
	const {
		isEditingTrigger,
		recapStock,
		recapStockFilters,
		kioskPerimeter,
		user,
		userRolePrivileges,
		filtersStock,
		translations,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			recapStock: state.recapStock,
			recapStockFilters: state.recapStock.header || false,
			kioskPerimeter: state.user.identity.kioskSelected,
			user: state.user,
			userRolePrivileges: state.user.identity.rolePrivileges,
			filtersStock: state.recapStock.filtersInfos,
			isEditingTrigger: state.columns.isEditingTrigger,
			translations: state.languages.translations,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)
	// endregion
	const recapStockActions = bindActionCreators(recapStockActionsCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	// Columns

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		const filtersCP = cloneDeep(filters)
		forEach(filtersCP.filtersSelection, (elem) => (elem.updated = false))
		setPrevFilter(filtersCP)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'kiosk.store.company.labelToDisplay', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		if (!isUndefined(pg)) {
			setPaging(pg)
			recapStockActions.postRecapStockRequest(handleFilterSend(), pg)
		}
	}

	const handlePutSubmit = (data, selectedData) => {
		recapStockActions.putRecapStockRequest({
			userKioskScope: { ...filters.userKioskScope },
			alertstockesDtos: reduce(
				data,
				(result, value, key) => {
					if (!value.alertStock || key === 'null') return result
					result.push({
						itemKioskId: key,
						kioskId: find(selectedData, { itemkioskId: Number(key) })['idKiosk'],
						newAlertStock: value.alertStock,
					})
					return result
				},
				[]
			),
		})
	}

	const handleFilterSend = () => {
		const filtersCp = cloneDeep(filters)

		filtersCp.withFilters = true
		filtersCp.userKioskScope = { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') }

		return { ...filtersCp }
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		// It seems when we set columns by useEffect,
		// toTranslate and toMapObject cannot work properly (even when we apply tests on it)
		setColumns([
			{
				columnReferential: 'summaryStock_kioskCode',
				dataHook: 'codeKiosk',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'summaryStock_kioskLabel',
				dataHook: 'labelKiosk',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_kioskLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'summaryStock_clientKioskCode',
				dataHook: 'codeKioskCustomer',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_kioskCustomerCode'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.codeKioskCustomer === '' || isNull(props.row.codeKioskCustomer) ? '-' : props.row.codeKioskCustomer),
				sortableId: 'kiosk.labelToOwner',
			},
			{
				columnReferential: 'summaryStock_family',
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_itemFamily'],
				sortable: true,
				//toTranslate: true,
				//toMapObject: true,
				isAuthorize: true,
				component: (props) => (props.row?.itemFamily?.translationKey ? translations[props.row.itemFamily.translationKey] : '-'),
				sortableId: 'itemDistributor.item.family.label',
			},
			{
				columnReferential: 'summaryStock_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_itemBrand'],
				sortable: true,
				toMapObject: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.brand.label',
			},
			{
				columnReferential: 'summaryStock_type',
				dataHook: 'typeItem',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_itemType'],
				sortable: true,
				toTranslate: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.itemType.translationKey.id',
			},
			{
				columnReferential: 'summaryStock_specificity',
				dataHook: 'itemSpecificity.translationKey',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_itemSpecificity'],
				sortable: true,
				//toTranslate: true,
				//toMApObject: true,
				isAuthorize: true,
				component: (props) => (props.row?.itemSpecificity?.translationKey ? translations[props.row.itemSpecificity.translationKey] : '-'),
				sortableId: 'itemDistributor.item.itemSpecificity.label',
			},
			{
				columnReferential: 'summaryStock_itemName',
				dataHook: 'labelItem',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_itemLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemDistributor.item.labelToDisplay',
			},
			{
				columnReferential: 'summaryStock_capacity',
				dataHook: 'kioskCapacity',
				headerName: `${translations['page__stockManagement__admin__itemTable_tableHeader_kioskCapacity']}(${recapStock?.columnsTable?.columnKioskCapacity})`,
				sortable: true,
				isAuthorize: true,
				sortableId: 'capacity',
			},
			{
				columnReferential: 'summaryStock_alert',
				dataHook: 'alertStock',
				headerName: translations['page__stockManagement__admin__itemTable_tableHeader_alertQty'],
				sortable: true,
				isAuthorize: true,
				edit: (props) => {
					return (
						(props?.row?.standardLine || isUndefined(props?.row?.standardLine)) && (
							<InputErrorTableWrapper errors={props?.error[props?.row?.itemkioskId]}>
								{props?.error[props?.row?.itemkioskId] && <ErrorInputTable src={ErrorSign} />}
								<InputTableRow
									type="number"
									defaultValue={!isUndefined(props?.storedValues) ? props?.storedValues?.alertStock : props?.row?.alertStock}
									name={`${props?.row?.itemkioskId}.alertStock`}
									ref={props?.register({
										min: 0,
										max: 100000,
										required: true,
									})}
								/>
								<> </>
							</InputErrorTableWrapper>
						)
					)
				},
				component: (props) => (!isNull(props?.row?.alertStock) ? `< ${props?.row?.alertStock}` : '-'),
				sortableId: 'stockAlert',
			},
			{
				columnReferential: 'summaryStock_lockerStock',
				dataHook: 'lockerStock',
				headerName: `${translations['page__stockManagement__admin__itemTable_tableHeader_lockerQty']}(${recapStock?.columnsTable?.columnLockerStock})`,
				sortable: true,
				isAuthorize: true,
				component: (props) => {
					let color = ''
					if (props.row.lockerStock === 0) {
						color = theme.colors.error
					} else if (props.row.alertStock >= props.row.lockerStock) {
						color = theme.colors.warning
					}
					return (
						(props.row.standardLine || isUndefined(props.row.standardLine)) && (
							<AlertStockColor color={color}>{props.row.lockerStock}</AlertStockColor>
						)
					)
				},
				sortableId: 'lockerStock',
			},

			{
				columnReferential: 'summaryStock_emptyLocker',
				dataHook: 'emptyLocker',
				headerName: `${translations['page__stockManagement__admin__itemTable_tableHeader_emptyLockerQty']}(${recapStock?.columnsTable?.columnEmptyLockers})`,
				sortable: true,
				isAuthorize: true,
				sortableId: 'emptyLocker',
			},
			{
				columnReferential: 'summaryStock_emptyBottle',
				dataHook: 'emptyStock',
				headerName: `${translations['page__stockManagement__admin__itemTable_tableHeader_emptyQty']}(${recapStock?.columnsTable?.columnEmptyStock})`,
				sortable: true,
				isAuthorize: true,
				sortableId: 'emptyStock',
			},
			{
				columnReferential: 'summaryStock_availableStock',
				dataHook: 'availableStock',
				headerName: `${translations['page__stockManagement__admin__itemTable_tableHeader_availableQty']}(${recapStock?.columnsTable?.columnAvailableStock})`,
				sortable: true,
				isAuthorize: true,
				sortableId: 'availableStock',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				rest: {},
				checkRight: userPrivileges.view[15],
			},
		])
	}, [translations, recapStock])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 7,
		labelPageTable: 'summaryStock',
	}

	useEffect(() => {
		// First URL is used when we came from redirect, to preload filters
		if (isEmpty(translations) || isUndefined(user)) return
		if (!isEmpty(filtersStock)) {
			recapStockActions.postRecapStockFromRedirect({
				withFilters: false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			})
			actionsColumns.setColumns([])
		} else if (isEmpty(recapStockFilters) && !isSorting) {
			recapStockActions.postRecapStockRequest({
				withFilters: false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			})
			actionsColumns.setColumns([])
			setFilters({ ...filters, ...recapStockFilters })
		}

		// Carefull, user store is changing because we can modify displayed columns.
		// So we need to control filters to prevent resetting them.
		// Not controlling can result in errors when exporting for example.
		if (filters.withFilters) {
			setConfigTable({
				...configTable,
				export: {
					privilege: userPrivileges.export[11],
					url: urlExport[6],
					bd: {
						filtersSelection: filters.filtersSelection,
						withFilters: true,
						userKioskScope: {
							kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
						},
					},
				},
			})
		} else {
			setConfigTable({
				...configTable,
				export: {
					privilege: userPrivileges.export[11],
					url: urlExport[6],
					bd: {
						withFilters: false,
						userKioskScope: {
							kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
						},
					},
				},
			})
		}
	}, [translations, user])

	useEffect(() => {
		return function cleanUp() {
			recapStockActions.resetRecapStock()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	// Preloading filters, which act as filtered search if we came from redirect
	useEffect(() => {
		if (isEmpty(translations) || isUndefined(user)) return
		// Clone recapStockFilters
		let recapStockFiltersCp = cloneDeep(recapStockFilters)
		// Test if filters stock object && recapStockFiltersCp  are not empty
		// To set filter for the call
		if (!isEqual(filtersStock, {}) && !isEqual(recapStockFiltersCp, {})) {
			// We are filtering by item, so we need to get the list
			const itemLabels = get(recapStockFiltersCp.filtersSelection, 'itemLabels', {})
			// We pass all active values to false
			map(itemLabels.filterElements, (elem, key) => (elem.active = false))
			// Get row index corresponding to receive filters
			const id = findIndex(itemLabels.filterElements, (f) => f.id === filtersStock.itemId)
			// Get row corresponding to receive filters
			// We name profile the filter element
			let profile = find(itemLabels.filterElements, (f) => f.id === filtersStock.itemId)

			// Change value of active key
			const profilMaj = { id: profile?.id, label: profile?.label, active: true }
			// Create merge  of old a new profil
			let profilMerge = { ...profile, ...profilMaj }
			// Yo prevent error we return if index a index are equal to -1

			if (id === -1) {
				return
			} else {
				// We add to filters the new profile
				recapStockFiltersCp.filtersSelection.itemLabels.filterElements[id] = profilMerge
				recapStockFiltersCp.filtersSelection.itemLabels.updated = true
			}

			// Also adding kiosk code filter
			const kioskIds = get(recapStockFiltersCp.filtersSelection, 'kioskIds', {})
			// We pass all active values to false
			map(kioskIds.filterElements, (elem, key) => (elem.active = false))
			// Get row index corresponding to receive filters
			const id2 = findIndex(kioskIds.filterElements, (f) => f.label === filtersStock.codeKioskManufacturer)
			// Get row corresponding to receive filters
			// We name profile the filter element
			let profile2 = find(kioskIds.filterElements, (f) => f.label === filtersStock.codeKioskManufacturer)

			// Change value of active key
			const profilMaj2 = { id: profile2?.id, label: profile2?.label, active: true }
			// Create merge  of old a new profil
			let profilMerge2 = { ...profile2, ...profilMaj2 }
			// Yo prevent error we return if index a index are equal to -1
			if (id2 === -1) {
				return
			} else {
				// We add to filters the new profile
				recapStockFiltersCp.filtersSelection.kioskIds.filterElements[id2] = profilMerge2
				recapStockFiltersCp.filtersSelection.kioskIds.updated = true
			}

			if (!isUndefined(filtersStock.codeKioskCustomerId)) {
				// Also adding customer kiosk code filter
				const kioskBrandLabels = get(recapStockFiltersCp.filtersSelection, 'kioskBrandLabels', {})
				// We pass all active values to false
				map(kioskBrandLabels.filterElements, (elem, key) => (elem.active = false))
				// Get row index corresponding to receive filters
				const id3 = findIndex(kioskBrandLabels.filterElements, (f) => f.label === filtersStock.codeKioskCustomer)
				// Get row corresponding to receive filters
				// We name profile the filter element
				let profile3 = find(kioskBrandLabels.filterElements, (f) => f.label === filtersStock.codeKioskCustomer)

				// Change value of active key
				const profilMaj3 = { id: profile3?.id, label: profile3?.label, active: true }
				// Create merge  of old a new profil
				let profilMerge3 = { ...profile3, ...profilMaj3 }
				// Yo prevent error we return if index a index are equal to -1
				if (id3 === -1) {
					return
				} else {
					// We add to filters the new profile
					recapStockFiltersCp.filtersSelection.kioskBrandLabels.filterElements[id3] = profilMerge3
					recapStockFiltersCp.filtersSelection.kioskBrandLabels.updated = true
				}
			}

			// We set filter for the call
			recapStockFiltersCp.withFilters = true
			recapStockFiltersCp.userKioskScope = { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') }

			recapStockActions.postRecapStockRequest(recapStockFiltersCp)
			recapStockActions.resetFiltersInfos()
		}
	}, [recapStockFilters, filtersStock])

	useEffect(() => {
		const filtersCp = cloneDeep(recapStockFilters)

		filtersCp.withFilters = true
		filtersCp.userKioskScope = { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') }

		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [recapStockFilters, kioskPerimeter])

	const handlePagingRecap = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'kiosk.store.company.labelToDisplay',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		setPaging(pg)

		recapStockActions.postRecapStockRequest(handleFilterSend(), pg)
	}
	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.massEdit = !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[9]))
		cfgCp.actions = {
			// edit attribute can have declared two methods :
			// - validate triggered on handleOnSubmit method of Table component
			// - cancel is passed as fn argument on handleCloseForm method of Table component
			edit: !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[9]))
				? {
						validate: (data, selectedData) => {
							handlePutSubmit(data, selectedData)
						},
						inlineEdit: inLineEdit,
						setInlineEdit: setInlineEdit,
				  }
				: null,
		}
		cfgCp.export = {
			privilege: userPrivileges.export[11],
			url: urlExport[6],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters, prevFilter, inLineEdit, recapStock])

	useEffect(() => {
		setConfigTableTitle({
			name: translations['page__stockManagement__admin__itemTable_subTitle'],
			paging: {
				totalElements: recapStock.paging.totalElements,
				totalPages: recapStock.paging.totalPages,
				fnSendTo: (paging) => handlePagingRecap(paging),
			},

			actions: {
				rest: [
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_itemFamily']}
							data={filters.filtersSelection?.families?.filterElements || []}
							translations={translations}
							toTranslate
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'families'}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_itemBrand']}
							data={filters.filtersSelection?.brands?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'brands'}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_itemType']}
							data={filters.filtersSelection?.itemTypes?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'itemTypes'}
							toTranslate={true}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_itemLabel']}
							data={filters.filtersSelection?.itemLabels?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'itemLabels'}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_kioskCode']}
							data={filters.filtersSelection?.kioskIds?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'kioskIds'}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__stockManagement__admin__itemTable_tableFilter_kioskName']}
							data={filters.filtersSelection?.kioskBrandLabels?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'kioskBrandLabels'}
						/>
					),
				],
			},
		})
	}, [translations, filters, prevFilter, inLineEdit, recapStock])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(kioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			recapStockActions.postRecapStockRequest(
				{
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
				},
				paging
			)
		setCurrentPerimeterKiosks(kioskPerimeter)
	}, [kioskPerimeter])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={recapStock.items}
				inputConfig={configTable}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={recapStockActions.postRecapStockRequest}
			/>
		)
	}, [recapStock, columns, configTable, translations, paging])

	return (
		<Fragment>
			<UsersManagerWrapper>
				<div onClick={() => setIsSorting(true)}>
					{!isUndefined(translations) && (
						<TableTitle
							inputConfig={configTableTitle}
							inputColumns={columns}
							test={isEditingTrigger}
							tableReferential={tableReferential}
						/>
					)}
					{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
				</div>
			</UsersManagerWrapper>
		</Fragment>
	)
}

RecapStock.propTypes = {}

RecapStock.defaultPropTypes = {}

export default RecapStock
